import { ReactNode } from 'react';

import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Dialog, DialogContent, DialogFooter, DialogHead, DialogHeader, DialogTitle } from 'src/registry/ui/Dialog';
import { generalMessages } from 'src/utils/messages';

interface LoadingModalProps {
    isLoading: boolean;
    title?: ReactNode;
    onCancel?: () => void;
}

const LoadingModal = ({ isLoading, title, onCancel }: LoadingModalProps) => {
    return (
        <Dialog open={isLoading} modal>
            <DialogContent
                onOpenAutoFocus={(e) => {
                    e.preventDefault();
                }}
                showCloseButton={false}
                className="flex items-center justify-center"
            >
                <DialogHeader className="max-w-sm py-4 text-center">
                    <DialogHead>
                        <DialogTitle className="pr-0">
                            {title || <FormattedMessage {...generalMessages.loading} />}
                        </DialogTitle>
                    </DialogHead>
                </DialogHeader>
                <FontAwesomeIcon className="text-primary-700 size-12 animate-spin py-4" icon={faSpinnerThird} />
                {onCancel && (
                    <DialogFooter>
                        <Button variant="destructive" onClick={onCancel}>
                            <FormattedMessage {...generalMessages.cancel} />
                        </Button>
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default LoadingModal;
